import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';
import { BrandLogo } from '@/components/layout/BrandLogo';
import { storeMetrics } from '@/data/storeMetrics';

export function Footer() {
  return (
    <footer className="border-t border-surface-200 bg-surface-950 text-white pb-[calc(3.75rem+env(safe-area-inset-bottom))] lg:pb-0">
      <div className="container-app py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="mb-3">
              <BrandLogo size="compact" imageClassName="brightness-0 invert" />
            </div>
            <p className="text-sm leading-relaxed text-white/55">
              Venta en línea del mismo almacén que usamos en instalación y servicio.{' '}
              {storeMetrics.aniosOperacion} años de operación,{' '}
              {storeMetrics.instalacionesRegistradas.toLocaleString('es-MX')} proyectos registrados.
            </p>
          </div>

          <div>
            <h4 className="mb-3 text-xs font-semibold text-white/40">Tienda</h4>
            <ul className="space-y-2 text-sm text-white/65">
              <li><Link to="/catalogo" className="hover:text-white">Catálogo</Link></li>
              <li><Link to="/kits" className="hover:text-white">Kits</Link></li>
              <li><Link to="/checkout" className="hover:text-white">Carrito / checkout</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-xs font-semibold text-white/40">Legal</h4>
            <ul className="space-y-2 text-sm text-white/65">
              <li>
                <Link to="/terminos" className="hover:text-white">
                  Términos y condiciones
                </Link>
              </li>
              <li>
                <Link to="/aviso-privacidad" className="hover:text-white">
                  Aviso de privacidad
                </Link>
              </li>
              <li>
                <a
                  href="https://www.openpay.mx/terminos-condiciones"
                  className="hover:text-white"
                  target="_blank"
                  rel="noreferrer"
                >
                  Términos Openpay
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-xs font-semibold text-white/40">Contacto</h4>
            <ul className="space-y-2.5 text-sm text-white/65">
              <li className="flex items-start gap-2">
                <Mail className="mt-0.5 h-4 w-4 shrink-0 text-brand-400" />
                <a href="mailto:ventas@alarcom.mx" className="hover:text-white">ventas@alarcom.mx</a>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brand-400" />
                <span>Lunes a viernes, horario de oficina</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-400" />
                <a href="https://www.alarcom.mx" className="hover:text-white" target="_blank" rel="noreferrer">
                  www.alarcom.mx
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-white/40 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Grupo Alarcom</p>
          <div className="flex flex-wrap gap-x-4 gap-y-1">
            <Link to="/terminos" className="hover:text-white">
              Términos y condiciones
            </Link>
            <Link to="/aviso-privacidad" className="hover:text-white">
              Aviso de privacidad
            </Link>
            <a
              href="https://www.openpay.mx/terminos-condiciones"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white"
            >
              Pagos con Openpay
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
